import { WHITE_COLLAR_FIRST_PC_CODES, WHITE_COLLAR_STATUTE_CODES } from '../constants';
import { DictionaryItem, StatuteCodeEnum } from '../models';

/**
 * For white collar committees (e.g. PC 300) moves white collar statutes before the rest,
 * keeping the original relative order within each group. Other PC codes are returned as is.
 */
export function sortStatutesByPcCode(
  statutes: Array<DictionaryItem<StatuteCodeEnum>>,
  pcCode?: string
): Array<DictionaryItem<StatuteCodeEnum>> {
  if (!pcCode || !WHITE_COLLAR_FIRST_PC_CODES.has(pcCode)) {
    return statutes;
  }

  const whiteCollar = statutes.filter(({ code }) => WHITE_COLLAR_STATUTE_CODES.has(code));
  const others = statutes.filter(({ code }) => !WHITE_COLLAR_STATUTE_CODES.has(code));

  return [...whiteCollar, ...others];
}
